module.exports = __webpack_public_path__ + "apple-store.4328fc1.png";